import React, { useEffect, useState, useContext } from "react";

import LoadingContext from "../../context/Loading/Loading";
import UserContext from "../../context/User/User";
import AuthService from "../../utilities/services/auth.service";

import { ORGANIZATION_PERMISSION_SLUGS } from "@blocktickets/shared-utils";
import { checkPermission, getDefaultSeason } from "../../utilities/helpers";

import { getSeasons } from "../../utilities/api";

import Card from "react-bootstrap/Card";

import { SeasonSelector } from "../SeasonSelector";
import { FlexPacksList } from "./FlexPacksList";
import { PageLoadingContainer } from "../PageLoadingContainer";
import { NoPermissionsContainer } from "../NoPermissionsContainer";
import { EmptyContainer } from "../EmptyContainer";

export default function FlexPacksWrapper({ organization }) {
  const { isLoading, showLoading, hideLoading } = useContext(LoadingContext);
  const { orgPermissions } = useContext(UserContext);
  const { getPermissions } = AuthService;

  const orgPermissionsReady = orgPermissions?.length > 0;
  const hasPermission =
    orgPermissionsReady &&
    checkPermission(
      getPermissions(),
      ORGANIZATION_PERMISSION_SLUGS.VIEW_FLEX_PACKAGES,
    );

  const [seasons, setSeasons] = useState();

  const [season, setSeasonSelected] = useState("");

  const loadSeasons = () => {
    getSeasons(organization.uuid)
      .then((res) => {
        setSeasons(res.data);
        // select the current season - start and end time is in between current time
        const selected = getDefaultSeason(res.data);

        if (selected) setSeasonSelected(selected?.id);
      })
      .catch((err) => console.error(err))
      .finally(() => hideLoading());
  };

  useEffect(() => {
    if (!orgPermissionsReady) return;
    if (!hasPermission) {
      hideLoading();
      return;
    }

    showLoading();
    loadSeasons();
  }, [orgPermissionsReady, hasPermission, organization?.uuid]);

  if (!orgPermissionsReady) {
    return <PageLoadingContainer style="without-sidebar" />;
  }

  if (!hasPermission) {
    return (
      <div className="spacer-sm">
        <NoPermissionsContainer style="without-sidebar" />
      </div>
    );
  }

  if (isLoading) {
    return <PageLoadingContainer style="without-sidebar" />;
  }

  return (
    <section className="spacer-sm" data-testid="flex-packs-wrapper-content">
      <div className="mb-4">
        <SeasonSelector
          seasons={seasons}
          selected={season}
          setSelected={setSeasonSelected}
        />
      </div>
      {season ? (
        <FlexPacksList
          organizationUUID={organization?.uuid}
          seasonId={season}
        />
      ) : (
        <Card body>
          <EmptyContainer style="center lg">
            <p>Select a season to view its flex packages</p>
          </EmptyContainer>
        </Card>
      )}
    </section>
  );
}
